<script setup lang="ts">
import BadgeCheckbox from '../shared/BadgeCheckbox.vue'
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

const props = defineProps<{
  type: ElementalTypeEnum
  isAllActive: boolean
}>()

const { toggleFilter, getView, state } = useElementalListsStore()

const view = getView(props.type)
const total = computed(() => {
  const values
  = view.value?.listCount.values()
  let acc = view.value?.count ?? 0
  if (!values)
    return acc

  for (const v of values)
    acc += v

  return acc
})
</script>

<template>
  <BadgeCheckbox
    v-if="view"
    class="flex-nowrap flex-shrink-0"
    :is-all-selected="isAllActive"
    :model-value="view.filterActive"
    @update:model-value="toggleFilter(view.elementaltype)"
  >
    <template #default="{ isChecked }">
      <span>
        {{ view.label }}
      </span>
      <BubbleCount
        v-if="state.query"
        :is-active="isChecked"
      >
        {{ total }}
      </BubbleCount>
    </template>
  </BadgeCheckbox>
</template>
